import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nieuw restaurant',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Nieuwe demo',
        [CompanyCreationModes.full]: 'Nieuw restaurant',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Restaurantinfo',
        [CompanyCreationSteps.BusinessInfo]: 'Bedrijfsinfo',
        [CompanyCreationSteps.AdditionalLocations]: 'Extra restaurants',
      },
    },
    business_profile: {
      legal_info: 'Juridische info',
      owner_info: 'Eigenaarsinfo',
    },
    recently_created: 'Recent aangemaakt',
  },
  form: {
    franchise: {
      label: 'Restaurant aanmaken',
      tooltip:
        'Geef aan of u een volledig nieuw merk aanmaakt of dit restaurant toevoegt aan een bestaand merk in ons systeem.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Nieuw merk aanmaken',
          tooltip: 'We beginnen vanaf nul — geen bestaand merk of restaurant',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Dit restaurant toevoegen aan een bestaand merk',
          tooltip: 'Het behoort al tot een merk in het systeem',
        },
      },
    },
    restaurants: {
      label: 'Gekoppeld(e) restaurant(s)',
    },

    business_profile: {
      label: 'Wie is de eigenaar?',
      tooltip:
        'Behoort dit restaurant tot een eigenaar/bedrijf dat al bestaat in ons systeem (bijv. “Luís Pizza GmbH”)? <br/> Zo ja, selecteer het bestaande eigenaar-/bedrijfsprofiel. Maak anders een nieuw profiel aan.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Nieuw eigenaar-/bedrijfsprofiel aanmaken',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Bestaand eigenaar-/bedrijfsprofiel gebruiken',
      },
    },
    business_type: {
      label: 'Bedrijfstype',
      placeholder: 'Selecteer bedrijfstype',
      options: {
        [BusinessType.Company]: 'Bedrijf',
        [BusinessType.Individual]: 'Eenmanszaak',
      },
    },
    display_name: {
      label: 'Restaurantnaam',
      placeholder: 'Weergavenaam',
    },
    legal_name: {
      label: 'Juridische naam',
      placeholder: 'Juridische naam',
    },
    owner_first_name: {
      label: 'Voornaam contactpersoon',
      placeholder: 'James',
    },
    owner_last_name: {
      label: 'Achternaam contactpersoon',
      placeholder: 'Bond',
    },
    owner_phone_number: {
      label: 'Telefoonnummer contactpersoon',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mail contactpersoon',
      placeholder: 'E-mailadres invoeren',
    },
    password: {
      label: 'Wachtwoord',
      placeholder: 'Wachtwoord invoeren',
    },

    additional_companies: {
      label: 'Extra restaurants onder dit merk',
      tooltip:
        'Zijn er extra restaurants onder hetzelfde merk als {{company}}? <br/> Zo ja, klik op “Restaurant toevoegen” om meer locaties toe te voegen. Zelfde eigenaar maar ander merk? Maak het dan apart aan.',
    },
  },
  labels: {
    create_demo: 'Demo aanmaken',
    create_company: 'Restaurant aanmaken',
    business_type: 'Bedrijfstype',
    display_name: 'Weergavenaam',
    legal_name: 'Juridische naam',
    owner_name: 'Naam eigenaar',
    address: 'Adres',
  },
  fields: {
    name: 'Naam',
    created_at: 'Aangemaakt',
    actions: 'Acties',
  },

  buttons: {
    add_restaurant: '+ Restaurant toevoegen',
    continue: 'Doorgaan',
    back: 'Terug',
    create: 'Restaurant aanmaken',
    delete: 'Verwijderen',
  },
  popups: {
    delete_demo: {
      title: 'Zeker verwijderen?',
    },
  },
  toasts: {
    company_created: 'Restaurant succesvol aangemaakt',
    failed_to_create_company: 'Restaurant aanmaken mislukt',
    failed_to_delete_demo: 'Demo verwijderen mislukt',
    demo_got_deleted: 'Demo succesvol verwijderd',
    failed_to_load_recently_created_companies: 'Recent aangemaakte restaurants laden mislukt',
  },
};
